import { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Button } from '@mui/material';

import { Iconify } from 'src/components/iconify';
import AuditLogDialog from 'src/pages/admin/components/AuditLog/AuditLogDialog';
import { PermissionGuard } from 'src/routes/components/permission-guard';

import { VAULT_PARAMS_AUDIT_RESOURCE } from './constants';

interface ParamsHistoryButtonProps {
  /** The audited key: the BFF records Core and Risk saves under `core` / `risk`. */
  recordId: 'core' | 'risk';
  /** i18n key of the card title, appended to the dialog title. */
  cardTitle: string;
}

/**
 * Change history of one parameter key, in the shared AuditLogDialog — the same
 * pattern the other config screens use, gated on `audit-logs` read like the
 * audit screen itself (XBIT-4164).
 */
export const ParamsHistoryButton = ({ recordId, cardTitle }: ParamsHistoryButtonProps) => {
  const translate = useTranslate();
  const [open, setOpen] = useState(false);

  return (
    <PermissionGuard resource="audit-logs" action="read" fallback={null} loadingFallback={null}>
      <Button
        size="small"
        variant="outlined"
        color="inherit"
        startIcon={<Iconify icon="ph:note" />}
        onClick={() => setOpen(true)}
        sx={{ flexShrink: 0, alignSelf: { xs: 'stretch', sm: 'auto' } }}
      >
        {translate('resource.auditLogs')}
      </Button>
      <AuditLogDialog
        open={open}
        onClose={() => setOpen(false)}
        resource={VAULT_PARAMS_AUDIT_RESOURCE}
        recordId={recordId}
        title={`${translate('resource.auditLogs')} - ${translate(cardTitle)}`}
      />
    </PermissionGuard>
  );
};
